import _ from 'lodash';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LTR, SUPPORTED_LANGUAGES } from 'arbitrip-common/translation/const';

const SupplierTerms = ({ getHotelOrHotelInfoPropertyByKey, showOriginalExternal }) => {
	const { t, i18n } = useTranslation();
	const lang = i18n?.language;
	const base = getHotelOrHotelInfoPropertyByKey('supplier_terms');
	const stTranslations = getHotelOrHotelInfoPropertyByKey('supplier_terms_translations') || {};
	const translated = lang && lang !== SUPPORTED_LANGUAGES.EN ? stTranslations[lang] : null;
	const translatedExists = !!translated;
	const [showOriginalState] = useState(false);
	const showOriginal = typeof showOriginalExternal === 'boolean' ? showOriginalExternal : showOriginalState;
	const forceOriginalTitles = !!showOriginal;
	const tr = (key) => (forceOriginalTitles ? t(key, { lng: SUPPORTED_LANGUAGES.EN }) : t(key));
	const supplier_terms = !showOriginal && translatedExists ? translated : base;
	const dirForContent = useMemo(() => (showOriginal ? LTR : i18n.dir()), [showOriginal, i18n]);

	if (supplier_terms) {
		const checkin_begin_time = _.get(supplier_terms, 'checkin.check_in_begin_time');
		const checkin_end_time = _.get(supplier_terms, 'checkin.check_in_end_time');
		const fromLabel = tr('CheckInOutTime.From');
		const tillLabel = tr('CheckInOutTime.Till');
		const checkin_time_text =
			`${checkin_begin_time ? `${fromLabel} ${checkin_begin_time}` : ''} ${checkin_end_time ? `${tillLabel} ${checkin_end_time}` : ''}`.trim();
		const checkout_time = _.get(supplier_terms, 'checkout.checkout_time');
		const checkin_24_hour = _.get(supplier_terms, 'checkin.checkin_24_hour');
		const check_in_instructions = _.get(supplier_terms, 'checkin.check_in_instructions');
		const check_in_special_instructions = _.get(supplier_terms, 'checkin.check_in_special_instructions');
		const check_in_min_age = _.get(supplier_terms, 'checkin.check_in_min_age');
		const fees_mandatory = _.get(supplier_terms, 'fees.fees_mandatory');
		const fees_optional = _.get(supplier_terms, 'fees.fees_optional');
		const policies_know_before_you_go = _.get(supplier_terms, 'policies.policies_know_before_you_go');

		return (
			<div className="supplier-terms-container">
				<div dir={dirForContent}>
					<div className="supplier-terms-wrapper">
						<div className="title">{tr('HotelPolicies')}</div>
						{checkin_time_text ? (
							<p>
								<strong>{tr('CheckInTime')}:</strong> {checkin_time_text}
							</p>
						) : null}
						{checkout_time ? (
							<p>
								<strong>{tr('CheckOutTime')}:</strong> {checkout_time}
							</p>
						) : null}
						{checkin_24_hour ? (
							<p>
								<strong>{tr('HourCheckIn')}</strong>
							</p>
						) : null}
						{check_in_instructions ? (
							<p>
								<strong>{tr('CheckInInstructions')}:</strong> {check_in_instructions}
							</p>
						) : null}
						{check_in_special_instructions ? (
							<p>
								<strong>{tr('CheckInSpecialInstructions')}:</strong> {check_in_special_instructions}
							</p>
						) : null}
						{check_in_min_age ? (
							<p>
								<strong>{tr('MinimumCheckInAge')}:</strong> {check_in_min_age}
							</p>
						) : null}
						{fees_mandatory ? (
							<p>
								<strong>{tr('MandatoryFees')}:</strong> {fees_mandatory}
							</p>
						) : null}
						{fees_optional ? (
							<p>
								<strong>{tr('OptionalFees')}:</strong> {fees_optional}
							</p>
						) : null}
						{policies_know_before_you_go ? (
							<p>
								<strong>{tr('YouNeedToKnow')}:</strong> {policies_know_before_you_go}
							</p>
						) : null}
					</div>
				</div>
			</div>
		);
	}

	return null;
};

export default SupplierTerms;
